export default class ReceiptData {
    [k: string]: string;

    public constructor({
        name,
        phone,
        email,
    }: Record<string, string | undefined>) {
        Object.entries({ name, phone, email }).forEach(([key, value]) => {
            if (value) {
                this[key] = value;
            }
        });
    }
}
